import { css } from "@emotion/react";
import { vars } from "@imwebme/clay-token";
import type { OptionListProps } from ".";

export const optionListCSS = ({ popOver }: Pick<OptionListProps, "popOver">) =>
  css({
    display: "flex",
    flexDirection: "column",
    gap: vars.spacing[1],

    paddingTop: vars.spacing[2],
    paddingBottom: vars.spacing[2],

    borderRadius: vars.rounded.medium,

    ...(popOver && {
      backgroundColor: vars.semantic.color.surface,
      boxShadow: vars.dropShadow.layer,

      paddingLeft: vars.spacing[2],
      paddingRight: vars.spacing[2],
    }),
  });
